<template>
  <div id="app" @click="clicked">
    <el-container :class="[$route.meta.single ? 'is-vertical fullheight' : '']">
      <template v-if="!single">
        <Menu></Menu>
        <el-container>
          <el-header height="48px"><Navigator /></el-header>
          <el-main style="margin: 0; padding: 11px; height: calc(100vh - 75px); overflow: auto; background: #f2f3f5">
            <el-card class="app-box__card" :class="{ 'box-card-noheader': !showHeader }" shadow="never">
              <keep-alive v-if="$route.meta.keepAlive">
                <router-view class="fullheight" @menuChange="handleMenuChange"></router-view>
              </keep-alive>
              <router-view class="fullheight" v-else @menuChange="handleMenuChange"></router-view>
            </el-card>
          </el-main>
        </el-container>
      </template>
      <router-view v-else />
    </el-container>
  </div>
</template>
<script>
import Navigator from '@/views/Navigator.vue'
import Menu from '@/views/Menu.vue'

export default {
  name: 'app',
  components: { Navigator, Menu },
  data() {
    return {
      single: true,
      showHeader: true,
      currentMenuLabel: '',
      menuShow: true,
      timer: null,
      whiteList: ['dev-platform.eco.com', 'localhost'],
      lastTime: new Date().getTime(), // 最后一次点击的时间
      currentTime: new Date().getTime(), //当前时间
      overTime: 30 * 60 * 1000 //默认超时时间(30分钟)
    }
  },
  mounted() {
    //定时触发判断是否未点击
    this.timer = setInterval(this.checkTime, 3000)
    // 因为resize事件在整个项目中只能监听一次，所以这里通过全局广播发送这个事件
    // window.onresize = () => {
    //   this.$root.$emit("resize");
    // };
    // menu.getMenuByAlias(this.$route.name, m => {
    //   if (m) {
    //     this.$emit("menuChange", m);
    //   }
    // });
  },
  destroyed() {
    clearInterval(this.timer)
  },
  watch: {
    $route: function (newVal, oldVal) {
      this.single = newVal.meta.single
    }
  },
  methods: {
    handleMenuChange: function (menu) {
      this.currentMenuLabel = menu.name
      this.showHeader = !(menu.children && menu.children.length > 0)
    },
    clicked() {
      this.lastTime = new Date().getTime() //当界面被点击更新点击时间
    },
    checkTime() {
      if (this.whiteList.indexOf(location.hostname) > -1) return false
      if (sessionStorage.getItem('currentUser')) {
        let user = JSON.parse(sessionStorage.getItem('currentUser'))
        if (user.overTime) {
          let minute = parseInt(user.overTime)
          this.overTime = minute * 60 * 1000
        }
      }
      this.currentTime = new Date().getTime()
      if (this.currentTime - this.lastTime > this.overTime) {
        if (sessionStorage.getItem('currentUser')) {
          // 退出登录
          let loginRouthPath = localStorage.getItem(this.$store.state.login.currentUser.account + 'loginRoutePath') || '/login'
          this.$store.dispatch('login/logoutAndCleanUp').then(() => {
            this.$router.push({
              path: loginRouthPath
            })
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/common.scss';

#app {
  background: #f5f5f5;
}
.app-box__card {
  border: 0;
  height: inherit;
  /deep/.el-card__body {
    padding: 0 10px !important;
    height: inherit;
  }
}
/deep/.el-table--border th {
  border-bottom: 1px solid #e0e0e0;
}
/deep/.el-table--border th,
.el-table--border td {
  border-right: 1px solid #e0e0e0;
}
/deep/.el-table th.is-leaf,
.el-table td {
  border-bottom: 1px solid #e0e0e0;
}
</style>
